import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SiteViewerVersionComponentSelector from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';
import { CheckCircleIcon, WarningIcon } from 'zoomforth_component_lib/external_modern_icons.jsx';
import FormInputLabel from './form_input_label.jsx';
import {
  formValuePropType,
  questionPropType,
  textareaQuestionPropType
} from './prop_types.js';

export const FormTextAreaInput_ViewerVersion2 = ({
  question,
  formValue,
  uniqueFormString,
  onQuestionChange,
  onQuestionTouch
}) => (
  <Fragment>
    <FormInputLabel {...{ question, uniqueFormString }} />
    <div className="form-input">
      <textarea
        aria-describedby={question.isRequired ? null : 'optional-description'}
        id={`${question.name}-${uniqueFormString}`}
        name={question.name}
        value={formValue.value}
        placeholder={question.placeholder}
        onBlur={() => onQuestionTouch(question)}
        onChange={(e) => onQuestionChange(question, e.target.value)}
      />
      <span className="form-input-status-icon-container">
        {formValue.error ?
          <WarningIcon className="form-input-status-icon" />
          :
          <CheckCircleIcon className="form-input-status-icon" />
        }
      </span>
    </div>

    <div className="form-input-error">
      <p className="form-input-error-text">Please fill in this field.</p>
    </div>
  </Fragment>
);

FormTextAreaInput_ViewerVersion2.propTypes = {
  formValue: formValuePropType.isRequired,
  question: textareaQuestionPropType.isRequired,
  onQuestionChange: PropTypes.func.isRequired,
  onQuestionTouch: PropTypes.func.isRequired
};

export const FormTextAreaInput_ViewerVersion1 = ({
  question,
  formValue,
  onQuestionTouch,
  onQuestionChange
}) => (
  <Fragment>
    <label htmlFor={question.name} className="form-field-label">
      {question.label} {question.isRequired && <span className="form-field-required-indicator">*</span>}
    </label>
    <textarea
      className={classnames(
        'form-field',
        'form-field-textarea',
        formValue.error ? 'error' : ''
      )}
      data-field-type="textarea"
      name={question.name}
      value={formValue.value}
      onBlur={() => onQuestionTouch(question)}
      onChange={(e) => onQuestionChange(question, e.target.value)}
    />
  </Fragment>
);

FormTextAreaInput_ViewerVersion1.propTypes = {
  formValue: formValuePropType.isRequired,
  question: questionPropType.isRequired,
  onQuestionChange: PropTypes.func.isRequired,
  onQuestionTouch: PropTypes.func.isRequired
};

const FormTextAreaInput = (props) => (
  <SiteViewerVersionComponentSelector>
    <FormTextAreaInput_ViewerVersion1 forSiteViewerVersion={1} {...props} />
    <FormTextAreaInput_ViewerVersion2 forSiteViewerVersion={2} {...props} />
  </SiteViewerVersionComponentSelector>
);

export default FormTextAreaInput;